/*
 * Copy for the password screen in front of the public deck preview
 * (`/preview`). The gate is a soft deterrent only — see `DeckPreviewGate`
 * for why it is not real protection.
 */

export const DECK_PREVIEW_GATE = {
  title: "This deck is private.",
  blurb: "Enter the password to view it.",
  label: "Password",
  show: "Show password",
  hide: "Hide password",
  submit: "View the deck",
  error: "That's not the right password. Try again.",
} as const
